export default __webpack_public_path__ + "static/media/errorLight.5de0fdc4.png";